import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { RoutesService, ShuttlesService, SummaryService, TicketsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TRoute, TRoutesViewModel } from '@shared/models';

@Component({
    'selector': 'app-route6Save',
    'templateUrl': './route6Save.page.html',
    'styleUrls': ['./route6Save.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class Route6SavePage extends ViewBasePage implements OnInit, OnDestroy {
    public vm: TRoutesViewModel;

    constructor(private ticketsService: TicketsService, private shuttlesService: ShuttlesService,
         private summaryService: SummaryService,
        private routesService: RoutesService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_ROUTE_PAGE6);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.vm = super.getViewModel();
        // this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.pushPopoverMenuItem('Show Tour', 'show-route-6-tour');
    // }

    public onNextClick() {
        if (this.vm.step6Complete) {
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/routes/route7Notification');
        } else {
            this.uxHelperService.showAlert('Error', 'Route has not been saved.');
        }
    }

    public async onSaveRouteClick() {
        // At the very moment this shuttle updated a ticket status to 'completed' is
        // when a copy of the ticket was copied over to the Trips node.
        // The completed ticket still lives under the tickets node.  It should not be
        // deleted until the RouteWizard saves a new route for this shuttle.
        // And that time is right now.
        //
        // 1) For this shuttle, remove all the prior completed tickets.

        try {
            await this.uxHelperService.showSpinner('Saving.');

            this.vm.selectedShuttle = await this.shuttlesService.updateShuttleToAssigned(this.vm.selectedShuttle.uid);
            await this.ticketsService.updateTicketsToAssigned(this.vm.selectedTickets);

            // Check the vm.selectedTickets status.  Do they have a status of assigned?
            const route: TRoute = {
                'shuttle': this.vm.selectedShuttle,
                'routeLegs': this.vm.routeLegs,
                'selectedTickets': this.vm.selectedTickets,
                'startingPoint': this.vm.startingPoint,
                'endingPoint': this.vm.endingPoint,
                'uid': this.vm.selectedShuttle.uid
                // 'createdDate': this.dateService.getMinimumDate()
            };

            // console.log('route:', route);
            await this.routesService.set(route);

            // await this.updateTicketsToAssigned();
            // await this.saveRoute();

            await this.uxHelperService.showToast('Saved.');
            this.vm.step6Complete = true;
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    // private async saveRoute(): Promise<TRoute> {
    //     try {
    //         // this.vm.route = {
    //         const route: TRoute = {
    //             'dealership': this.vm.dealership,
    //             'shuttle': this.vm.selectedShuttle,
    //             'routeLegs': this.vm.routeLegs,
    //             'selectedTickets': this.vm.selectedTickets,
    //             'startingPoint': this.vm.startingPoint,
    //             'endingPoint': this.vm.endingPoint,
    //             'uid': this.vm.selectedShuttle.uid
    //         };

    //         this.routesService.validate(route);
    //         // await this.routesService.set(this.vm.route);
    //         await this.routesService.set(route);
    //         return route;
    //     } catch (err) {
    //         console.error(err);
    //     }
    // }
}
